module.exports = __webpack_public_path__ + "media/goforajourney/img/france-card-ab8636ec68cecfb962f2f5a8d5ef7e79.webp";